<template>
  <div class="find_module">
    <div class="find_bag">
      <div v-for="(item,index) in findArr" :key="index" class="result_cup">
        <div>
          <el-divider></el-divider>
        </div>
        <div class="result_img" @click="viewNews(item.newsId)">
          <img :src="item.newsMainImg" width='160' height="101" alt="" class="img_info">
        </div>
        <div class="result_tip">
          <div v-html="item.newsTitle" class="r_news_title" @click="viewNews(item.newsId)"></div>
          <div v-html="item.newsText"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { sysSearch } from '@/api/frontApi/common';
export default {
  data() {
    return {
      findArr: [],
      keyWord: '',
      pageNo: 1,
      pageSize: 10
    };
  },
  computed: {
    defaultImg() {
      return this.$store.state.defaultImg;
    }
  },
  created() {
    this.keyWord = this.$route.query.qtext;
    this.findList(this.keyWord);
  },
  methods: {
    findList(keyWord) {
      sysSearch({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        keywords: keyWord
      }).then(res => {
        res.data.list.forEach(item => {
          if (!item.newsMainImg) {
            item.newsMainImg = this.defaultImg;
          }
        });
        this.findArr = res.data.list;
      });
    },
    viewNews(newsId) {
      this.$router.push({
        name: 'newsInfo',
        params: {
          newsId: newsId
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.find_module {
  width: 100%;
  min-height: 600px;
  background-color: #fff;
}

.find_bag {
  width: 80%;
  margin: 0 auto;
  padding: 10px;
  min-width: 969px;

  .result_cup {
    width: 100%;
    overflow: hidden;
    margin-bottom: 10px;
    min-width: 949px;
    max-height: 125px;
    padding-bottom: 10px;

    .result_img {
      float: left;
      width: 160px;
      margin-right: 10px;
      height: 101px;
      overflow: hidden;

      .img_info {
        overflow: hidden;
        transition: all 0.6s;
        cursor: pointer;
      }

      .img_info:hover {
        transform: scale(1.2);
      }
    }

    .result_tip {
      float: left;
      width: 82.5%;
      min-width: 720px;

      .r_news_title:hover {
        cursor: pointer;
        color: #275295;
      }
    }
  }

  .result_cup >>>.key_word {
    color: #409EFF;
    font-weight: bold;
    fomt-size: 16px;
  }
}

.color1 {
  color: #f56c6c;
}

.color2 {
  color: #409eff;
}

.color3 {
  color: #67c23a;
}

.color4 {
  color: #e6a23c;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/findList/results.vue